<template>
    <div class="social-auth-buttons">
        <SocialAuthError />
        <SocialButton
            v-if="showFacebook"
            :provider="FACEBOOK"
            :show-error="false"
            :button-text="type === 'login' ? $t(`modals.login.facebook_button`) : $t(`modals.signup.facebook_button`)"
            :signup-redirect-to="signupRedirectTo"
            :error-redirect-to="errorRedirectTo"
            @auth-started="$emit('social-auth-started', FACEBOOK)"
            @logged-in="$emit('logged-in')"
        />
        <SocialButton
            v-if="showGoogle"
            :provider="GOOGLE"
            :show-error="false"
            :button-text="type === 'login' ? $t(`modals.login.google_button`) : $t(`modals.signup.google_button`)"
            :signup-redirect-to="signupRedirectTo"
            :error-redirect-to="errorRedirectTo"
            @auth-started="$emit('social-auth-started', GOOGLE)"
            @logged-in="$emit('logged-in')"
        />
    </div>
</template>

<script>
import { FACEBOOK, GOOGLE } from '~/config/authMethods';
import SocialButton from '~/components/onboarding/SocialButton';
import SocialAuthError from '~/components/onboarding/SocialAuthError';

export default {
    name: 'SocialAuthButtons',
    components: { SocialAuthError, SocialButton },
    props: {
        type: {
            type: String,
            default: 'login',
        },
        signupRedirectTo: {
            type: Object,
            default: null,
        },
        errorRedirectTo: {
            type: Object,
            default: null,
        },
        showFacebook: {
            type: Boolean,
            default: true,
        },
        showGoogle: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            FACEBOOK,
            GOOGLE,
        };
    },
};
</script>

<style scoped lang="scss">
.social-auth-buttons {
    .social-button:not(:first-child) {
        margin-top: 24px;
    }
}
</style>
